import React from "react";
import icon_right_arrow from "bodycodi/cmap/app/svg/icon_right_arrow.svg";

type ConsumedPass = {
  cnt: number;
  remainNumber: number;
  from: string;
  to: string;
  attendanceState?: string;
};

const ConsumedPass = ({ cnt, remainNumber, from, to, attendanceState }: ConsumedPass) => {
  const fromTitle = cnt === 1000 ? "무제한" : `${remainNumber}회`;
  const toTitle = cnt === 1000 ? "무제한" : `${remainNumber + cnt}회`;

  return (
    <>
      <div className="member-decution">
        {attendanceState !== "approve" && to === "E" && (
          <>
            출석요청 허가시
            <br />
          </>
        )}
        {cnt === 0 || cnt === 1000 ? (
          <>이용권의 잔여횟수가 유지됩니다.</>
        ) : (
          <>
            이용권의 잔여횟수가 {Math.abs(cnt)}회 {cnt > 0 ? "복구" : "차감"}됩니다.
          </>
        )}
      </div>
      <div className="member-decution-cnt">
        <ul>
          <li className="count">{fromTitle}</li>
          {from === "R" && <li className="union blue">예약</li>}
          {from === "E" && <li className="union green">출석</li>}
          {from === "S" && <li className="union light-green">출석요청중</li>}
        </ul>
        <img src={icon_right_arrow} />
        <ul>
          <li className="count bold">{toTitle}</li>
          {to === "E" && <li className="union green">출석</li>}
          {to === "A" && <li className="union red">결석</li>}
        </ul>
      </div>
    </>
  );
};

export default ConsumedPass;
